export function rfidLocation() {
  return new Promise(resolve => {
    const missing = locationError => resolve({ latitude: null, longitude: null, locationError });
    if (!navigator.geolocation) return missing('unsupported');
    navigator.geolocation.getCurrentPosition(
      position => resolve({ latitude: position.coords.latitude, longitude: position.coords.longitude }),
      error => missing(({ 1: 'denied', 3: 'timeout' })[error.code] || 'unavailable'),
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
    );
  });
}
